import { EntityType } from "@mapmycustomers/shared/enum";
import { EntityTypeSupportingGroups } from "@mapmycustomers/shared/types/entity";

// A group mention resolves to its underlying entity for both the access
// pre-flight (saga) and the navigation target (hook).
export const GROUP_TO_ENTITY: Partial<Record<EntityType, EntityTypeSupportingGroups>> = {
  [EntityType.COMPANY_GROUP]: EntityType.COMPANY,
  [EntityType.DEAL_GROUP]: EntityType.DEAL,
  [EntityType.PEOPLE_GROUP]: EntityType.PERSON,
};
